import { useSelector } from 'react-redux';
import { selectUser } from '../selectors/auth';

/**
 * Returns the current logged-in user from Redux (single source of truth).
 * Use this instead of reading from localStorage in components.
 */
export function useLoggedUser() {
    return useSelector(selectUser);
}
